import { useMutation } from '@tanstack/react-query';
import FileDownload from 'js-file-download';

import { useToasts } from '../../../cdl/Toast/useToasts';
import { downloadVesselProductsForVessel } from '../../../common/api/clients/vessel.api';
import { extractFileName } from '../../../common/helpers/extractFileName.helper';
import { translate } from '../../../common/helpers/translate.helper';

export const useVesselProductsDownload = () => {
    const { addLoadingToast } = useToasts();
    const { mutateAsync: executeVesselProductsDownload } = useMutation({
        mutationFn: downloadVesselProductsForVessel,
    });

    return async (vesselId: string) => {
        return addLoadingToast(
            () =>
                executeVesselProductsDownload(vesselId, {
                    onSuccess: (response) =>
                        FileDownload(
                            response.data,
                            extractFileName(response.headers['content-disposition'] || '', 'VesselProducts.xlsx')
                        ),
                }),
            translate('vessel.products.downloading'),
            translate('vessel.products.downloadSuccess'),
            translate('vessel.products.downloadError')
        );
    };
};
